import React from 'react'
import { Directortext } from '../Codeofconduct/Code.element'
import { Directorbackground, Main, Sub } from './Schoolcommittee.element'




function Schoolmanagementcommittee() {
    return (
        <Main>
               <Directorbackground>
                <Directortext>
                    <h1>School Management Committee</h1>
                    <p>The New Era Public School| <span>School Management Committee</span> </p>
                </Directortext>
                </Directorbackground> 

<Sub>

<table class="table">
  <thead>
    <tr>
      <th scope="col">Name & Address</th>
      <th scope="col">Designation</th>
      <th scope="col">Occupation</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Ram krishna Lyengar </td>
      <td>Chairman</td>
      <td>Educationalist</td>
    </tr>
    <tr>
      <td>Dr.SM Holker</td>
      <td>Joint Executive Secretary</td>
      <td>Educationalist</td>
    </tr>
    <tr>
    <td>Dyuti Sardesai</td>
      <td>Member Secretary</td>
      <td>Principal</td>
    </tr>
    <tr>
    <td>Anand Mohan Mathur</td>
      <td>Member</td>
      <td>Senior,Advocate</td>
    </tr>
    <tr>
    <td>Sanjay Joshi</td>
      <td>Member</td>
      <td>Advocate,Highcourt</td>
    </tr>
    <tr>
    <td>Abhay Paliwal</td>
      <td>Member</td>
      <td>Asst. Professor MGM,Medical College</td>
    </tr>
    <tr>
    <td>Vasant Bochare</td>
      <td>Member</td>
      <td>Hon.Sec Dayananda Shikshan samiti</td>
    </tr>
    <tr>
    <td>Jayashree Agnihotri</td>
      <td>Member</td>
      <td>Principal,Motherland Convent </td>
    </tr>
    <tr>
    <td>Swapna Shivnekar</td>
      <td>Member</td>
      <td>Principal Adarsh Shishu Vihar</td>
    </tr>
    <tr>
    <td>Sangeeta Londhe</td>
      <td>Member</td>
      <td>Senior Teacher,Bal Niketan Sangh</td>
    </tr>
    <tr>
    <td>Patidar</td>
      <td>Member Parent</td>
      <td>Business</td>
    </tr>
    <tr>
    <td>Pravin Keole</td>
      <td>Member Parent</td>
      <td>Banking</td>
    </tr>
    <tr>
    <td>Prakash Kulkarni</td>
      <td>Lecturer</td>
      <td>Govt. School</td>
    </tr>
    <tr>
    <td>Mahesh</td>
      <td>DEO</td>
      <td>Dhar</td>
    </tr>
    
  </tbody>
 
</table>

</Sub>


        </Main>
    )
}

export default Schoolmanagementcommittee
